import { AdapterFactory } from '../AdapterFactory';

export const technicianService = AdapterFactory.getTechnicianAdapter();
